import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { ArrowLink, CloudinaryPicture } from '@bwoty-web/ui-kit';
import SectionParagraph from '../../../../common/sectionParagraph';
import './roomTypeList.scss';

const RoomTypeList = ({
  roomTypes,
  labels,
  toggleRoomInfo,
}) => {
  const filteredRoomTypes = roomTypes.some((i) => i.bookingType === 'cp')
    ? roomTypes.filter((i) => i.bookingType === 'cp')
    : roomTypes;

  return (
    <div className="gw-room-type-list">
      {filteredRoomTypes.map((roomType) => {
        const {
          name,
          texts,
          wvId,
          accommodationSupplier,
          imageVideoList,
        } = roomType;

        if (!name || accommodationSupplier !== 'own') {
          return null;
        }

        const hasNoImage = !imageVideoList?.[0]?.cloudinaryUriTemplate;

        return (
          <div className="gw-room-type-list-item" key={uniqid('room-type')}>
            <div className="gw-room-type-list-item__image-container">
              {hasNoImage && (
                <div className="gw-room-type-list-item__no-image-overlay">
                  <span>{labels?.roomImageMissing}</span>
                </div>
              )}
              <CloudinaryPicture
                sizes={[
                  {
                    width: 360,
                    height: 240,
                    breakpoint: 768,
                  },
                  {
                    width: 747,
                    height: 200,
                    breakpoint: 480,
                  },
                  {
                    width: 459,
                    height: 200,
                    breakpoint: 376,
                  },
                  {
                    width: 355,
                    height: 200,
                  },
                ]}
                img={imageVideoList?.[0]}
                lazy
              />
            </div>
            <div className="gw-room-type-list-item__info-container">
              <h3 className="gw-room-type-list-item__heading">{name}</h3>
              {texts.map((paragraph) => {
                return (
                  <SectionParagraph
                    key={uniqid('room-type-paragraph')}
                    paragraph={paragraph}
                  />
                );
              })}
              <ArrowLink onClick={() => toggleRoomInfo(wvId)}>
                {labels.showRooms}
              </ArrowLink>
            </div>
          </div>
        );
      })}
    </div>
  );
};

RoomTypeList.propTypes = {
  roomTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  siteSettings: PropTypes.shape({
    imageDomain: PropTypes.string,
  }).isRequired,
  labels: PropTypes.shape({
    showRooms: PropTypes.string,
    roomImageMissing: PropTypes.string,
  }).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
};

export default RoomTypeList;
